import { NavSideBarStateType } from '../types';

export const navSideBarState: NavSideBarStateType = {
  open: false,
};
